<template>
<v-text-field class="mobile-input" :value="displayValue" @input="onInput" @keydown="onKeyDown" :rules="computedRules" maxlength="9" prepend-inner="09" label="شماره همراه" v-bind="$attrs" v-on="$listeners" />
</template>


<script>
export default {
  name: 'MyMobile',

  props: {
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // فقط 9 رقم بعد از 09 نمایش داده میشه
    displayValue() {
      if (!this.value) return ''
      return this.value.replace(/^09/, '')
    },

    computedRules() {
      const rules = []

      if (this.required) {
        rules.push(v => !!v || 'الزامی')
      }

      rules.push(v =>
        (!v || v.length === 9) || 'شماره باید 11 رقمی باشد'
      )

      return rules
    }
  },

  methods: {
    onKeyDown(e) {
      const allowed = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
      ]

      if (allowed.includes(e.key)) return

      // فقط اعداد انگلیسی
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault()
      }
    },

    onInput(val) {
      val = val || ''

      // تبدیل اعداد فارسی به انگلیسی 👇
      val = val
        .replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        .replace(/\D/g, '')

      // محدود به 9 رقم
      val = val.slice(0, 9)

      // اضافه کردن 09
      const full = val ? '09' + val : ''

      this.$emit('input', full)
    }
  }
}
</script>

<style>
.mobile-input input {
  direction: ltr;
  text-align: left;
}
</style>
